import { withTranslation } from 'react-i18next';

function Aboutus({ t }) {
    return (
        <div className=" px-12 py-12 mt-12">
            <div className="text-center text-secondary text-5xl font-bold">{t("aboutus.title")}</div>
            <div className="text-center my-6 px-2 sm:px-24 text-xl font-bold">
                <div>{t("aboutus.introduction1")}</div>
                <div className='mt-10'>{t("aboutus.introduction2")}</div>
                <div className='mt-10'>{t("aboutus.introduction3")}</div>
            </div>
        </div>
    );
}


export default withTranslation()(Aboutus);